import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import { Text } from 'preact-i18n';

import AdventQuizDoor from './doors/quizDoor';
import AdventTextDoor from './doors/textDoor';
import AdventStatsDoor from './doors/statsDoor';
import AdventSponsorDoor from './doors/sponsorDoor';
import AdventGameDoor from './doors/gameDoor';
import AdventChallengeDoor from './doors/challengeDoor';
import { DOOR_TYPE_LABELS } from '../../lib/adventCalendar';

const RENDERERS = {
    quiz: AdventQuizDoor,
    text: AdventTextDoor,
    stats: AdventStatsDoor,
    sponsor: AdventSponsorDoor,
    game: AdventGameDoor,
    challenge: AdventChallengeDoor,
};

/** Bottom drawer «adventDoor»: shows the content of one opened door (props: day). */
@observer
class AdventDoorDrawer extends Component {
    close = () => {
        const { appState } = this.props.stores;
        const { drawerLevel = 1 } = this.props;
        appState.toggleDrawer(false, drawerLevel);
    }

    render() {
        const { day, drawerLevel = 1 } = this.props;
        const { adventCalendarStore } = this.props.stores;
        const door = adventCalendarStore.doorContent[day];
        const Renderer = door ? RENDERERS[door.type] : null;
        return (
            <div class='w-100 d-flex justify-content-center'>
                <div class='w-100' style='max-width: 720px; padding-top: 20px; padding-bottom: 100px;'>
                    <div class='px-3'>
                        <div class='d-flex align-items-center justify-content-between mb-3'>
                            <h5 class='mb-0'>
                                🎁 <Text id='adventCalendar.doorTitle' fields={{ day }}>Door {day}</Text>
                                {door ? <span class='badge bg-body-secondary text-body ms-2'>{DOOR_TYPE_LABELS[door.type]}</span> : null}
                            </h5>
                            <button type='button' class='btn btn-sm btn-outline-secondary' onClick={this.close}>
                                <Text id='adventCalendar.close'>Close</Text>
                            </button>
                        </div>
                        {Renderer ? (
                            <Renderer stores={this.props.stores} door={door} day={day} drawerLevel={drawerLevel} />
                        ) : (
                            <div class='text-body-secondary'><i class='fa-solid fa-spinner fa-spin' /></div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default AdventDoorDrawer;
